import { SVGIconProps } from '../icons.types';

export const FileUploadIcon = ({ ...rest }: SVGIconProps) => {
	return (
		<svg {...rest} width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect width="40" height="40" rx="8" fill="#F5F5F5" />
			<path
				d="M11 32C10.175 32 9.46875 31.7063 8.88125 31.1188C8.29375 30.5313 8 29.825 8 29V24.5H11V29H29V24.5H32V29C32 29.825 31.7063 30.5313 31.1188 31.1188C30.5313 31.7063 29.825 32 29 32H11ZM18.5 26V13.775L14.6 17.675L12.5 15.5L20 8L27.5 15.5L25.4 17.675L21.5 13.775V26H18.5Z"
				fill="#0F152F"
			/>
		</svg>
	);
};
